import { createAction, props } from '@ngrx/store';
import { IOrganization, IUser, OrganizationStatus } from '@shared/models';

export enum ActionTypes {
  Load        = '[Members] Load',
  LoadSuccess = '[Members] Load Success',
  LoadFail    = '[Members] Load Fail'
}

export const load = createAction(
  ActionTypes.Load
);

export const loadSuccess = createAction(
  ActionTypes.LoadSuccess,
  props<{ members: IUser[] }>()
);

export const loadFail = createAction(
  ActionTypes.LoadFail,
  props<{ error: string }>()
);

